import { render, staticRenderFns } from "./LangEdit.vue?vue&type=template&id=98bf5f4a&"
import script from "./LangEdit.vue?vue&type=script&lang=js&"
export * from "./LangEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports